import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ChartFilterControlsInterface, ReportInputTypes } from 'src/app/shared/models/common';

@Component({
  selector: 'app-user-activity-client-occupation',
  templateUrl: './user-activity-client-occupation.component.html',
  styleUrls: ['./user-activity-client-occupation.component.css']
})
export class UserActivityClientOccupationComponent implements OnInit {

  public hideFilters: boolean = false
  public clientOccupationForm: FormGroup
  public clientOccupationFormControls: ChartFilterControlsInterface[] = [
    { name: ReportInputTypes.CLIENT, type: 'CLIENT', position: 'right' },
    { name: ReportInputTypes.LOAN_PRODUCT, type: 'LOAN_PRODUCT', position: 'right' },
  ]
  
  constructor() { }

  ngOnInit(): void {
  }

  filterClientOccupation(ev: any) {
  }

}
